import React, { useRef, useEffect } from 'react';
import { withFirebase } from '../../components/Firebase';
import { REACT_APP_BASE_URL } from '../../env';
import Spinner from '../../components/Spinner';
import Utilities from '../../utils/utilities';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { StyledTable, StyledTableHead, StyledTableCell, StyledTableRow } from '../../components/Table';
import { ChargeCodeToolTip } from './components/chargeCodeToolTip';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { ThemeContext } from '../../components/Session';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';
import QuoteTerms from '../Quote/terms';

import moment from 'moment';

const styles = (theme) => ({
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  bottomMargin: {
    marginBottom: theme.spacing(3),
  },
  topMargin: {
    marginTop: theme.spacing(3),
  },
  logo: {
    maxHeight: '50px',
    maxWidth: '200px',
  },
  muted: {
    color: theme.palette.grey[400],
    fontWeight: 'normal',
  },
  opacity1: {
    opacity: 1,
  },
  flexOne: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  tableWrapper: {
    // position: 'relative',
    // height: '100%',
    display: 'inline-block',
    maxWidth: '100%',
    borderRadius: theme.spacing(1),
    // minHeight: '300px',
    // overflow: 'hidden',
    '& thead tr th': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    '& tbody tr td': {
      lineHeight: `${theme.spacing(1.75)}px`,
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  },
  table: {
    // position: 'absolute',
    // height: '100%',
    // maxWidth: '100%',
    // width: 'auto',
  },
  leftBorderThick: {
    borderLeft: `3px ${theme.palette.grey[400]} solid`,
  },
  leftBorderThin: {
    borderLeft: `1px ${theme.palette.grey[400]} solid`,
  },
  alignTop: {
    verticalAlign: 'top',
  },
  small: {
    fontSize: '9px',
    paddingTop: '2px',
  },
});

class CustomerViewRateSheetContents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: 'none',
      loading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ratesheet_id !== this.props.ratesheet_id) {
      this.loadRateSheet();
    }
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.loadRateSheet();
  }

  loadRateSheet() {
    return this.props.firebase
      .rateSheet(this.props.freight_forwarder_id, this.props.ratesheet_id, { publicRoute: true })
      .then((ratesheet) => {
        let currentFreightForwarder = ratesheet.freightForwarder;
        if (currentFreightForwarder.primaryColor) {
          this.context.updateTheme({
            ...this.props.theme,
            palette: {
              ...this.props.theme.palette,
              primary: {
                ...this.props.theme.palette.primary,
                main: currentFreightForwarder.primaryColor,
                dark: darken(currentFreightForwarder.primaryColor, 0.2),
                darker: darken(currentFreightForwarder.primaryColor, 0.4),
                light: lighten(currentFreightForwarder.primaryColor, 0.2),
                lighter: lighten(currentFreightForwarder.primaryColor, 0.9),
              },
            },
          });
        }
        ratesheet.tableHeaders = ratesheet.tableHeaders || [];
        let { tableHeaders } = ratesheet;
        let currencyCodesUsed = [];

        // duplicate charge for ALL containers so that they may be edited individually
        ratesheet.quotes.forEach((quote) => {
          let newCharges = [];
          quote.charges.forEach((charge) => {
            if (charge.container_key === 'ALL') {
              quote.containers.forEach((c) => {
                newCharges.push({ ...charge, container_key: c._id });
              });
            }
          });
          quote.charges = [...quote.charges.filter((c) => c.container_key !== 'ALL'), ...newCharges];
        });

        let { currencies, baseCurrencyCode } = currentFreightForwarder;
        // loop through chargeCategories to get the name and default sort order
        ratesheet.constants.chargeCategories.forEach((chargeCategory) => {
          ratesheet.quotes.forEach((quote) => {
            quote.charges.forEach((charge) => {
              const currency = currencies.find((c) => c._id === charge.currency_id);
              charge.currency = currency;
              const currencyCode = currency ? currency.code : baseCurrencyCode;
              if (!currencyCodesUsed.includes(currencyCode)) {
                currencyCodesUsed.push(currencyCode);
              }

              let tableHeader = tableHeaders.find((th) => th.charge_category_code === charge.charge_category_code);
              if (tableHeader) {
                let curChargeCode = tableHeader.chargeCodes.find((chargeCode) => chargeCode.code === charge.code);
                if (curChargeCode === undefined) {
                  tableHeader.chargeCodes.push({ code: charge.code });
                }
              } else {
                tableHeaders.push({
                  charge_category_code: charge.charge_category_code,
                  charge_category_name: chargeCategory.name,
                  chargeCodes: [{ code: charge.code }],
                });
              }

              // if (chargeCategory.code === charge.charge_category_code) {
              //     let curChargeCode = chargeCodes.find((chargeCode) => chargeCode.code === charge.code);
              //     if (curChargeCode) {
              //         // ensure the charge is in the same currency as this column
              //         // let fromConversion = currency ? currency.to_NZD : 1;
              //         // let toCurrency = currencies.find((c) => c.code === curChargeCode.currencyCode);
              //         // let toConversion = toCurrency ? toCurrency.to_NZD : 1;
              //         // charge.sellRate = (charge.sellRate * fromConversion) / toConversion;
              //     } else {
              //         chargeCodes.push({
              //             code: charge.code,
              //             charge_category_code: charge.charge_category_code,
              //             charge_category_name: chargeCategory.name,
              //         });
              //     }
              // }
            });
          });
        });

        this.setState({
          // chargeCodes,
          ratesheet,
          currentFreightForwarder,
          loading: false,
          currencyCodesUsed,
        });
      });
  }

  handleTableWidthChange = (width) => {
    this.setState({ maxWidth: width });
  };

  componentWillUnmount() {
    // this.unsubscribe();
  }

  render() {
    const { loading, ratesheet, currentFreightForwarder, currencyCodesUsed, maxWidth } = this.state;
    const { classes } = this.props;
    const terms_and_conditions =
      ratesheet && currentFreightForwarder
        ? currentFreightForwarder.terms_and_conditions.find((o) => o.mode === ratesheet.mode)
        : undefined;
    let termsObj;
    if (terms_and_conditions && currentFreightForwarder) {
      termsObj = {
        terms_and_conditions: terms_and_conditions.text,
        conditions_of_trade: currentFreightForwarder.conditions_of_trade,
      };
    }
    return (
      <React.Fragment>
        <Spinner visible={loading} />
        {ratesheet && loading === false && currentFreightForwarder && (
          <Box style={{ maxWidth: maxWidth }}>
            <Grid container spacing={3} className={classes.bottomMargin}>
              <Grid item xs>
                <div>
                  <img
                    alt={currentFreightForwarder.name}
                    src={Utilities.getPhotoUrl(currentFreightForwarder.logo_images, 'logo')}
                    className={classes.logo}
                  />
                </div>
              </Grid>
              <Grid item xs>
                <Grid container justifyContent="center">
                  <Typography variant="h1" color="primary">
                    Rate Sheet
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs></Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant="caption" color="primary" gutterBottom>
                  QUOTE FOR
                </Typography>
                {ratesheet && ratesheet.client && (
                  <React.Fragment>
                    <Typography variant="h5">{ratesheet.client.name}</Typography>
                    <Typography variant="h5">{ratesheet.client.address}</Typography>
                    <Typography variant="h5">{ratesheet.client.suburb}</Typography>
                    <Typography variant="h5">
                      {ratesheet.client.city}
                      {ratesheet.client.postCode && `, ${ratesheet.client.postCode}`}
                    </Typography>
                    <Typography variant="h5">{ratesheet.client.country}</Typography>
                  </React.Fragment>
                )}
              </Grid>
              <Grid item xs={6}>
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <Typography variant="h4" gutterBottom>
                      Rate Sheet #{ratesheet.rateSheetNumber}
                    </Typography>
                    <Typography variant="h5" className={classes.muted} align="right">
                      {currentFreightForwarder.name}
                    </Typography>
                    <Typography variant="h5" className={classes.muted} align="right">
                      {currentFreightForwarder.address}
                    </Typography>
                    <Typography variant="h5" className={classes.muted} align="right">
                      {currentFreightForwarder.suburb}
                    </Typography>
                    <Typography variant="h5" className={classes.muted} align="right">
                      {currentFreightForwarder.city}
                      {currentFreightForwarder.postCode && `, ${currentFreightForwarder.postCode}`}
                    </Typography>
                    <Typography variant="h5" className={classes.muted} align="right">
                      {currentFreightForwarder.country}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {ratesheet && (
              <Grid container spacing={3} className={classes.bottomMargin}>
                <Grid item xs>
                  <Typography variant="caption" color="primary">
                    START DATE
                  </Typography>
                  <Typography variant="h5">
                    {ratesheet.validFrom ? moment(ratesheet.validFrom).format('DD/MM/YYYY') : ''}
                  </Typography>
                </Grid>
                <Grid item xs>
                  <Typography variant="caption" color="primary">
                    EXPIRY DATE
                  </Typography>
                  <Typography variant="h5">
                    {ratesheet.validUntil ? moment(ratesheet.validUntil).format('DD/MM/YYYY') : ''}
                  </Typography>
                </Grid>
                <Grid item xs>
                  <Typography variant="caption" color="primary">
                    MODE
                  </Typography>
                  <Typography variant="h5">{ratesheet.mode}</Typography>
                </Grid>
                <Grid item xs>
                  <Typography variant="caption" color="primary">
                    MOVEMENT TYPE
                  </Typography>
                  <Typography variant="h5">{ratesheet.movementType}</Typography>
                </Grid>
                <Grid item xs>
                  <Typography variant="caption" color="primary">
                    INCOTERM
                  </Typography>
                  <Typography variant="h5">{ratesheet.incoterm.code}</Typography>
                </Grid>
                <Grid item xs>
                  <Typography variant="caption" color="primary">
                    PREPARED BY
                  </Typography>
                  <Typography variant="h5">{ratesheet.prepared_by}</Typography>
                </Grid>
                {ratesheet.prepared_for && ratesheet.prepared_for.length > 0 && (
                  <Grid item xs>
                    <Typography variant="caption" color="primary">
                      PREPARED FOR
                    </Typography>
                    <Typography variant="h5">{ratesheet.prepared_for.join(', ')}</Typography>
                  </Grid>
                )}
              </Grid>
            )}
            {/* <Grid container spacing={3} className={`${classes.flexOne} ${classes.bottomMargin}`}> */}
            <Grid container spacing={3} className={classes.bottomMargin}>
              <Grid item xs={12}>
                {ratesheet && (
                  <RateSheetsTable
                    onTableWidthChange={this.handleTableWidthChange}
                    ratesheet={ratesheet}
                    classes={classes}
                    currentFreightForwarder={currentFreightForwarder}
                  />
                )}
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs>
                {termsObj && <QuoteTerms quote={termsObj} />}
              </Grid>
              <Grid item>
                <Typography variant="h5" gutterBottom className={classes.topMargin}>
                  CURRENCY CONVERSIONS USED:
                </Typography>
                {currentFreightForwarder.currencies
                  .filter((currency) => currencyCodesUsed.includes(currency.code))
                  .map((currency) => {
                    return (
                      <Typography variant="subtitle2" key={currency._id} gutterBottom className={classes.opacity1}>
                        1 {currentFreightForwarder.baseCurrencyCode} = {parseFloat(1 / currency.to_NZD).toFixed(2)}{' '}
                        {currency.code}
                      </Typography>
                    );
                  })}
              </Grid>
            </Grid>
          </Box>
        )}
      </React.Fragment>
    );
  }
}

function RateSheetsTable(props) {
  const { classes, ratesheet, currentFreightForwarder, onTableWidthChange } = props;
  const { tableHeaders } = ratesheet;
  const { currencies } = currentFreightForwarder;
  const isAir = ratesheet.mode === 'AIR';

  const calculateTotal = (quote, container, field) => {
    // prettier-ignore
    return quote.charges.filter((charge) => charge.container_key === container._id)
        .reduce((partial_sum, charge) => {
            const currency = currencies.find(c => c._id === charge.currency_id);
            let conversion = currency ? (currency.to_NZD || 1) : 1
            return (partial_sum + parseFloat(charge[field] * conversion))
        }, 0)
        .toFixed(2);
  };

  const ref = useRef(null);
  useEffect(() => {
    onTableWidthChange(ref.current ? ref.current.offsetWidth : 0);
  }, [onTableWidthChange]);

  return (
    <div className={classes.tableWrapper} ref={ref}>
      <StyledTable className={classes.table} size="small">
        <StyledTableHead>
          <TableRow>
            {ratesheet.clientDisplay && ratesheet.clientDisplay.origin_location && <StyledTableCell></StyledTableCell>}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.destination_location && (
              <StyledTableCell></StyledTableCell>
            )}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.shipping_line && <StyledTableCell></StyledTableCell>}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.frequency && <StyledTableCell></StyledTableCell>}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.transit && <StyledTableCell></StyledTableCell>}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.validFrom && <StyledTableCell></StyledTableCell>}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.validUntil && <StyledTableCell></StyledTableCell>}
            <StyledTableCell></StyledTableCell>
            {tableHeaders.map((tableHeader, index) => {
              return tableHeader.chargeCodes && tableHeader.chargeCodes.length > 0 ? (
                <React.Fragment key={tableHeader.charge_category_code}>
                  <StyledTableCell
                    colSpan={tableHeader.chargeCodes.length}
                    width={45}
                    className={classes.leftBorderThick}
                  >
                    <Box fontWeight="fontWeightBold">{tableHeader.charge_category_name}</Box>
                  </StyledTableCell>
                </React.Fragment>
              ) : null;
            })}
            {/* total headers */}
            {ratesheet.clientDisplay.grandTotal && (
              <StyledTableCell className={classes.leftBorderThick}></StyledTableCell>
            )}
            {/* book now */}
            <StyledTableCell className={classes.leftBorderThin}></StyledTableCell>
          </TableRow>
          <TableRow>
            {ratesheet.clientDisplay && ratesheet.clientDisplay.origin_location && (
              <StyledTableCell width={70}>Origin</StyledTableCell>
            )}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.destination_location && (
              <StyledTableCell width={70}>Destination</StyledTableCell>
            )}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.shipping_line && (
              <StyledTableCell width={70}>Service Provider</StyledTableCell>
            )}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.frequency && (
              <StyledTableCell width={70}>Frequency</StyledTableCell>
            )}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.transit && (
              <StyledTableCell width={70}>Transit (days)</StyledTableCell>
            )}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.validFrom && (
              <StyledTableCell width={70}>Valid From</StyledTableCell>
            )}
            {ratesheet.clientDisplay && ratesheet.clientDisplay.validUntil && (
              <StyledTableCell width={70}>Valid To</StyledTableCell>
            )}
            <StyledTableCell width={70}>{isAir ? 'Weight Range' : 'Container'}</StyledTableCell>
            {tableHeaders.map((tableHeader, tableHeaderIndex) =>
              tableHeader.chargeCodes.map((chargeCode, chargeCodeIndex) => {
                return tableHeader.chargeCodes && tableHeader.chargeCodes.length > 0 ? (
                  <StyledTableCell
                    key={chargeCode.code}
                    width={45}
                    className={chargeCodeIndex === 0 ? classes.leftBorderThick : classes.leftBorderThin}
                  >
                    <ChargeCodeToolTip chargeCode={chargeCode} />
                  </StyledTableCell>
                ) : null;
              })
            )}
            {ratesheet.clientDisplay.grandTotal && (
              <StyledTableCell className={classes.leftBorderThick}>Total</StyledTableCell>
            )}
            <StyledTableCell width={120} className={classes.leftBorderThin}></StyledTableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {ratesheet &&
            ratesheet.quotes &&
            ratesheet.quotes.map((quote, quoteIndex) => {
              let { service } = quote;
              let allServices = [];
              if (ratesheet.services) {
                allServices.push(...ratesheet.services);
              }
              if (ratesheet.standAloneServices) {
                allServices.push(...ratesheet.standAloneServices);
              }
              let { origin, destination } = allServices[quoteIndex];

              // let { origin, destination } = ratesheet.services && ratesheet.services[quoteIndex];
              let subject = encodeURIComponent('New Freight Legend booking request');
              let rowObjects;
              if (isAir) {
                rowObjects = quote.charges
                  .map((c) => {
                    // add in an _id for comaprisons etc
                    return { ...c.weightRange, _id: c.weightRange.code };
                  })
                  .reduce((accum, curRow) => {
                    // no duplicates
                    if (accum.find((r) => r._id === curRow._id) === undefined) {
                      accum.push(curRow);
                    }
                    return accum;
                  }, []);
              } else {
                rowObjects = quote.containers;
              }
              // return quote.containers.map((container) => {
              return rowObjects.map((rowObject) => {
                let body = encodeURIComponent(
                  // prettier-ignore
                  `Booking ref: ${REACT_APP_BASE_URL}/freight-forwarders/${ratesheet.freight_forwarder_id}/ratesheets/${ratesheet._id}\r\n` +
                                    `${isAir ? 'Weight Range' : 'Container'}: ${isAir ? rowObject.code : rowObject.name}\r\n` +
                                    `Origin: ${origin && origin.port && origin.port.name}\r\n` +
                                    `Destination: ${destination && destination.port && destination.port.name}\r\n` + 
                                    `Service Provider: ${service.shipping_line}\r\n`
                );
                const sellRateTotal = calculateTotal(quote, rowObject, 'sellRate');
                return (
                  <StyledTableRow key={`${service._id}${rowObject._id}`}>
                    {ratesheet.clientDisplay && ratesheet.clientDisplay.origin_location && (
                      <StyledTableCell>{origin && origin.port && origin.port.name}</StyledTableCell>
                    )}
                    {ratesheet.clientDisplay && ratesheet.clientDisplay.destination_location && (
                      <StyledTableCell>{destination && destination.port && destination.port.name}</StyledTableCell>
                    )}
                    {ratesheet.clientDisplay && ratesheet.clientDisplay.shipping_line && (
                      <StyledTableCell>{service.shipping_line}</StyledTableCell>
                    )}
                    {ratesheet.clientDisplay && ratesheet.clientDisplay.frequency && (
                      <StyledTableCell>{service.frequency}</StyledTableCell>
                    )}
                    {ratesheet.clientDisplay && ratesheet.clientDisplay.transit && (
                      <StyledTableCell>{service.transit_time_days}</StyledTableCell>
                    )}
                    {ratesheet.clientDisplay && ratesheet.clientDisplay.validFrom && (
                      <StyledTableCell>
                        {service.validFrom ? moment(service.validFrom).format('DD/MM/YYYY') : ''}
                      </StyledTableCell>
                    )}
                    {ratesheet.clientDisplay && ratesheet.clientDisplay.validUntil && (
                      <StyledTableCell>
                        {service.validUntil ? moment(service.validUntil).format('DD/MM/YYYY') : ''}
                      </StyledTableCell>
                    )}
                    <StyledTableCell>{isAir ? rowObject.code : rowObject.name}</StyledTableCell>
                    {tableHeaders.map((tableHeader) => {
                      return tableHeader.chargeCodes.map((chargeCode, index) => {
                        const charge = quote.charges.find(
                          (charge) =>
                            charge.code === chargeCode.code &&
                            charge.charge_category_code === tableHeader.charge_category_code &&
                            charge.container_key === rowObject._id
                        );
                        return (
                          <StyledTableCell
                            key={chargeCode.code}
                            className={`${index === 0 ? classes.leftBorderThick : classes.leftBorderThin} ${
                              classes.alignTop
                            }`}
                          >
                            {charge ? (
                              <Box>
                                <Typography className={classes.small} variant="subtitle2">
                                  {charge.currency ? charge.currency.code : <br />}
                                </Typography>
                                <Box>{charge.sellRate.toFixed(2)}</Box>
                                {isAir && charge.code === 'FRT' ? (
                                  <Typography className={classes.small} variant="subtitle2">
                                    Min: ${quote.service.overallCharge.sellMinimum.toFixed(2)}
                                  </Typography>
                                ) : null}
                                <Typography className={classes.small} variant="subtitle2">
                                  {charge.unit_name}
                                </Typography>
                              </Box>
                            ) : (
                              '-'
                            )}
                          </StyledTableCell>
                        );
                      });
                    })}
                    {ratesheet.clientDisplay.grandTotal && (
                      <StyledTableCell className={`${classes.leftBorderThick} ${classes.alignTop}`}>
                        <Typography variant="subtitle2">{currentFreightForwarder.baseCurrencyCode}</Typography>
                        <Box>{sellRateTotal}</Box>
                      </StyledTableCell>
                    )}
                    <StyledTableCell className={classes.leftBorderThin}>
                      <Button
                        href={`mailto:${ratesheet.prepared_by_email}?subject=${subject}&body=${body}`}
                        disabled={!ratesheet.prepared_by_email}
                        target="_blank"
                        variant="contained"
                        color="primary"
                      >
                        <FontAwesomeIcon icon={faEnvelope} className={classes.leftIcon} />
                        Book Now
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              });
            })}
        </TableBody>
      </StyledTable>
    </div>
  );
}

CustomerViewRateSheetContents.contextType = ThemeContext;

CustomerViewRateSheetContents.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withFirebase, withStyles(styles, { withTheme: true }))(CustomerViewRateSheetContents);
